var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlancherSurVideSanitaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.66 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #94704a;\n      }\n\n      .cls-2 {\n        fill: #d3d3d3;\n      }\n\n      .cls-3 {\n        fill: #e8e8e8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.66 .15 105.21 .15 80.37 20.8 90.09 20.8 110.66 3.71 110.66 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.32 .15 0 13.72 0 20.8 1.19 20.8 26.03 .15 16.32 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 .15 0 3.32 3.81 .15 0 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.2 .15 0 4.48 0 12.56 14.92 .15 5.2 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.99 .15 58.15 20.8 67.87 20.8 92.71 .15 82.99 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.1 .15 69.26 20.8 78.98 20.8 103.82 .15 94.1 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.43 .15 2.59 20.8 12.31 20.8 37.15 .15 27.43 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.66 20.8 110.66 14.1 102.6 20.8 110.66 20.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.65 .15 24.81 20.8 34.53 20.8 59.37 .15 49.65 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.88 .15 47.04 20.8 56.75 20.8 81.59 .15 71.88 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.66 4.86 91.49 20.8 101.2 20.8 110.66 12.94 110.66 4.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.76 .15 35.93 20.8 45.64 20.8 70.48 .15 60.76 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.54 .15 13.7 20.8 23.42 20.8 48.26 .15 38.54 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.81 .15 0 3.32 0 4.48 5.2 .15 3.81 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.92 .15 0 12.56 0 13.72 16.32 .15 14.92 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.03 .15 1.19 20.8 2.59 20.8 27.43 .15 26.03 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.15 .15 12.31 20.8 13.7 20.8 38.54 .15 37.15 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.26 .15 23.42 20.8 24.81 20.8 49.65 .15 48.26 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.37 .15 34.53 20.8 35.93 20.8 60.76 .15 59.37 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.48 .15 45.64 20.8 47.04 20.8 71.88 .15 70.48 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.59 .15 56.75 20.8 58.15 20.8 82.99 .15 81.59 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.71 .15 67.87 20.8 69.26 20.8 94.1 .15 92.71 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.82 .15 78.98 20.8 80.37 20.8 105.21 .15 103.82 .15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.66 3.71 90.09 20.8 91.49 20.8 110.66 4.86 110.66 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.66 14.1 110.66 12.94 101.2 20.8 102.6 20.8 110.66 14.1"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.98,
    y1: 30.4,
    x2: 75.26,
    y2: 29.84
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.09,
    width: 79.05,
    height: 12.94
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlancherSurVideSanitaire);
export default __webpack_public_path__ + "static/media/plancher-sur-vide-sanitaire.f5154cfad8b8c2dd2380ff641998fee8.svg";
export { ForwardRef as ReactComponent };